import DamageCompensationCategoriesSelect from './DamageCompensationCategoriesSelect';

export default DamageCompensationCategoriesSelect;
